module.exports = __webpack_public_path__ + "img/Ciber.be411c82.png";